import * as React from 'react';
import { Modal, IModalProps } from '../Modal';
import Button from '../Button';
import { ICrop } from '../../infrastructure/interfaces';

export interface IChangeImageModalProps extends IModalProps {
  crop: ICrop | null;
  onSave(image: string): void;
}

export interface IChangeImageModalState {
  selectImage: string | null;
}

export default class ChangeImageModal extends React.Component<IChangeImageModalProps, IChangeImageModalState> {
  constructor(props: IChangeImageModalProps) {
    super(props);
    this.state = {
      selectImage: props.crop && props.crop.defaultImage,
    };
  }

  componentWillReceiveProps(nextProps: IChangeImageModalProps) {
    if (this.props.crop !== nextProps.crop) {
      this.setState({ selectImage: nextProps.crop && nextProps.crop.defaultImage });
    }
  }

  onSave = () => {
    const image = this.state.selectImage;
    if (image) {
      this.props.onSave(image);
    }
    this.props.onClose();
  }

  onClose = () => {
    this.props.onClose();
  }

  onSelect(image: string) {
    this.setState({ selectImage: image });
  }
  
  render() {
    return (
      <Modal show={this.props.show} onClose={this.onClose}>
        <Modal.Header>
          <Modal.Title>
            <h5>Change Image for {(this.props.crop != null) ? this.props.crop.name : ''}</h5>
          </Modal.Title>
          <Button bsClass="close" onClick={this.onClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="changeImageContainer">
            {(this.props.crop != null) && this.props.crop.images.map(img => (
              <div
                className={`changeImageModalImgContainer ${img === this.state.selectImage ? 'selected' : ''}`}
                key={img}
                onClick={() => this.onSelect(img)}
              >
                <img className="changeImageModalImg" src={img} />
                <div className="imgShadow">
                  <img src={require('./images/markImg.svg')} />
                  <span>Image Selected</span>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsClass="primary" onClick={this.onSave}>
            Save
          </Button>
          <Button onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/ChangeImageModal.tsx